<template>
  <div class="videos-carousel videos-carousel__swiper-container">
    <div
      ref="wrapper"
      class="swiper-wrapper"
      tabindex="-1"
    >
      <slot />
    </div>
    <div
      v-show="showArrows"
      class="swiper-button-prev button-nav button-nav--prev"
      aria-hidden="true"
    >
      <svg><use xlink:href="#chevron-left" /></svg>
    </div>
    <div
      v-show="showArrows"
      class="swiper-button-next button-nav button-nav--next"
      aria-hidden="true"
    >
      <svg><use xlink:href="#chevron-right" /></svg>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import _ from 'lodash'
import emitter from '../../../emitter'

export default {
  name: 'VideosCarousel',
  data() {
    return {
      swiper: null,
      showArrows: true
    }
  },
  mounted() {
    let count = 0
    const slides = this.$el.getElementsByClassName('swiper-slide')

    if (this.$slots) count = this.$slots.length

    this.swiper = new Swiper('.videos-carousel__swiper-container', {
      slidesPerView: 'auto',
      initialSlide: count < 3 ? 0 : 1,
      spaceBetween: 0,
      centeredSlides: true,
      slideToClickedSlide: true,
      // breakpointsInverse: true,
      breakpoints: {
        // when window width is <= 920px
        920: {
          slidesPerView: 2
        }
      },
      navigation: {
        nextEl: '.button-nav--next',
        prevEl: '.button-nav--prev',
      }
    })

    this.swiper.on('slideChange', this.onChange)
    window.addEventListener('resize', this.onResize, false)

    for (let i = 0; i < slides.length; i++) {
      slides[i].addEventListener('focus', (e) => {
        const list2 = this.$el.getElementsByClassName('swiper-slide')
        for (let j = 0; j < list2.length; j++) {
          if (list2[j] === e.target) {
            this.swiper.slideTo(j)
          }
        }
      })
    }
    this.$el.getElementsByClassName('button-nav').item(0).setAttribute('tabindex', -1)
    this.$el.getElementsByClassName('button-nav').item(1).setAttribute('tabindex', -1)
  },
  methods: {
    onResize() {
      this.swiper.update()
    },
    onChange() {
      const videos = _.filter(this.$children, item => item.$el.className === 'vt-video-container')
      emitter.$emit('vt-change-video', {
        id: videos[this.swiper.previousIndex].$children[0].id,
        command: 'stop'
      })
    }
  }
}
</script>
